// extracted by mini-css-extract-plugin
export default {"clickable":"styles_clickable__EicHQ"};